<template>
  <div><slot></slot></div>
</template>

<script>
import Headroom from 'headroom.js'

export default {
  name: 'MyHeadroom',
  data () {
    return {
      headroom: null
    }
  },
  mounted () {
    // let _this = this
    this.headroom = new Headroom(this.$el, {
      offset: 180,
      tolerance: 5
      // onTop () {
      //   _this.$store.commit('setHeadHeight', 80)
      // },
      // onUnpin () {
      //   _this.$store.commit('setHeadHeight', 0)
      // },
      // onPin () {
      //   _this.$store.commit('setHeadHeight', 80)
      // }
    })
    this.headroom.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/objects/MyHeadroom.vue